import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { MaintenanceCupiOptionalPart } from '../../../interfaces/Case';

interface IMaintenanceCupiOptionalPartState {
  newMaintenanceCupiOptionalPart: MaintenanceCupiOptionalPart;
  maintenanceOptionList: IReferential[];
  maintenanceCupiOptionalPartList: MaintenanceCupiOptionalPart[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newMaintenanceCupiOptionalPartId: number | null;
}

type IMaintenanceCupiOptionalPartProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;

class MaintenanceCupiOptionalPartComponent extends React.PureComponent<
  IMaintenanceCupiOptionalPartProps,
  IMaintenanceCupiOptionalPartState
> {
  private translatorService!: ITranslatorService;
  private caseService!: ICaseService;
  private appReferentialService!: IReferentialService;


  static contextType = ApplicationContext;
  private newMaintenanceCupiOptionalPart = {
    id: 0,
    maintenanceOptionalId: 0,
    cupiCode: null
  } as unknown as MaintenanceCupiOptionalPart;

  state = {
    maintenanceCupiOptionalPartList: [],
    isLoading: false,
    selectedFilter: 0,
    isDialogOpen: false,
    newMaintenanceCupiOptionalPart: this.newMaintenanceCupiOptionalPart,
    maintenanceOptionList: [],
    newMaintenanceCupiOptionalPartId: null
  } as IMaintenanceCupiOptionalPartState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadMaintenanceCupiOptionalPartList();
      }
    );
  }

  loadMaintenanceCupiOptionalPartList = async () => {
    const maintenanceCupiOptionalPartList = await this.caseService.MaintenanceCupiOptionalPartList();
    const ref = Referentials.referential.find(
      (item) => item.code === ReferentialCode.MaintenanceOption
    );
    const maintenanceOptionList = (await this.appReferentialService.Get(ref!.baseUrl)).filter((item) => item.isActive === true);

    this.setState({
      maintenanceCupiOptionalPartList: maintenanceCupiOptionalPartList,
      isLoading: false,
      maintenanceOptionList: maintenanceOptionList,
      newMaintenanceCupiOptionalPart: { ...this.newMaintenanceCupiOptionalPart }
    });
  };


 

  private handleMaintenanceOptionChange = (newValue: IReferential | null) => {
    this.setState({
      newMaintenanceCupiOptionalPart: {
        ...this.state.newMaintenanceCupiOptionalPart,
        maintenanceOption: newValue,
        maintenanceOptionId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleCupiCodeChange = (value: string) => {
    this.setState({
      newMaintenanceCupiOptionalPart: {
        ...this.state.newMaintenanceCupiOptionalPart,
        cupiCode: value
      }
    });
  };

  public saveMaintenanceCupiOptionalPart = async () => {
    if (this.state.newMaintenanceCupiOptionalPartId === null) {
      try {

        await this.caseService.AddMaintenanceCupiOptionalPart(this.state.newMaintenanceCupiOptionalPart);

        await this.loadMaintenanceCupiOptionalPartList();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {

        await this.caseService.UpdateMaintenanceCupiOptionalPart(this.state.newMaintenanceCupiOptionalPart);

        await this.loadMaintenanceCupiOptionalPartList();

        this.closeDialog();

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveMaintenanceCupiOptionalPart} instantValidate={true}>
        <Box mb={2}>
          <TextValidator
            fullWidth
            name="cupiCode"
            id="cupiCode"
            value={this.state.newMaintenanceCupiOptionalPart.cupiCode || ''}
            onChange={(e: any) => this.handleCupiCodeChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'MAINTENANCE_CUPI_PART_OPTIONAL_CUPI_CODE',
              'Cod Cupi'
            )}
            validators={['required']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="maintenanceOption"
            fullWidth
            options={this.state.maintenanceOptionList}
            value={this.state.newMaintenanceCupiOptionalPart.maintenanceOption}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleMaintenanceOptionChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="maintenanceOption"
                value={this.state.newMaintenanceCupiOptionalPart.maintenanceOption}
                label={this.translatorService.Tranlate(
                  'MAINTENANCE_CUPI_PART_OPTIONAL_NAME',
                  'Denumire Piesa'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>
        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }

  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'maintenanceOption',
        label: this.translatorService.Tranlate(
          'MAINTENANCE_CUPI_PART_OPTIONAL_NAME',
          'Denumire Piesa'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return a.name!.localeCompare(b.displayName!);
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'cupiCode',
        label: this.translatorService.Tranlate('MAINTENANCE_CUPI_PART_OPTIONAL_CUPI_CODE', 'Cod Cupi')
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newMaintenanceCupiOptionalPartPopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteMaintenanceCupiOptionalPart(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];

    return columns;
  };

  deleteMaintenanceCupiOptionalPart = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];

      await this.caseService.RemoveMaintenanceCupiOptionalPart(id);
      await this.loadMaintenanceCupiOptionalPartList();

      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };


  newMaintenanceCupiOptionalPartPopup = async (maintenanceCupiOptionalPartId: number | null) => {
    let newMaintenanceCupiOptionalPart: MaintenanceCupiOptionalPart;
    if (maintenanceCupiOptionalPartId == null) {
      newMaintenanceCupiOptionalPart = { ...this.state.newMaintenanceCupiOptionalPart } as MaintenanceCupiOptionalPart;
    } else {
      newMaintenanceCupiOptionalPart = this.state.maintenanceCupiOptionalPartList.find((item) => item.id === maintenanceCupiOptionalPartId)!;
    }
    this.setState({
      isDialogOpen: true,
      newMaintenanceCupiOptionalPart: newMaintenanceCupiOptionalPart,
      newMaintenanceCupiOptionalPartId: maintenanceCupiOptionalPartId
    });
  };

  closeDialog = async () => {
    this.setState(
        { 
          isDialogOpen: false, 
          newMaintenanceCupiOptionalPart: this.newMaintenanceCupiOptionalPart 
        }
      );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.caseService = (this.context as AppContext).caseService;
    this.appReferentialService = (this.context as AppContext).referentialService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newMaintenanceCupiOptionalPartPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };

    return (
      <Fragment>
    
       <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.maintenanceCupiOptionalPartList}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newMaintenanceCupiOptionalPartId ? 
                    this.translatorService.Tranlate(
                        'MAINTENANCE_CUPI_PART_OPTIONAL_ADD_MODAL_TITLE',
                        'Adauga Cod Cupi'
                      ) : this.translatorService.Tranlate(
                        'MAINTENANCE_CUPI_PART_OPTIONAL_UPDATE_MODAL_TITLE',
                        'Actualizeaza Cod Cupi'
                      )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) : null}
      </Fragment>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(MaintenanceCupiOptionalPartComponent as any));
